import { Injectable } from '@angular/core';

import { EnableClassTelemetry } from 'app/services/otel.service';
import { QueryParams } from './api.service';
import { DashboardType } from './bridge-api/dashboard.service';
import { StorageAPIService } from './storage-api.service';

interface TextSlot {
  token: string | null;
  description: string | null;
}

interface FieldSlot {
  token: string | null;
  description: string | null;
  label: string | null;
  fieldType: string | null;
}

interface DatasourceSlot {
  token: string | null;
  description: string | null;
  collectionRequirements: Record<string, boolean> | null;
  analysisRequirements: Record<string, boolean> | null;
}

interface AccountRequirements {
  features: string[] | null;
  limits: Record<string, string> | null;
  balances: Record<string, string> | null;
}

export interface Template {
  id: string;
  groupId: string;
  name: string;
  description: string;
  dashboardType: DashboardType;
  templateJson: string;
  textSlots: TextSlot[] | null;
  fieldSlots: FieldSlot[] | null;
  datasourceSlots: DatasourceSlot[] | null;
  accountRequirements: AccountRequirements | null;
  createdAt: string;
  modifiedAt: string;
}

interface Result<T> {
  count: number;
  results: T[];
}

@EnableClassTelemetry()
@Injectable({ providedIn: 'root' })
export class DashboardTemplatesService extends StorageAPIService {
  async list(groupId: string): Promise<Template[]> {
    const endpoint = `/backend/group/${groupId}/dashboard-templates`;
    const queryParams: QueryParams = { limit: StorageAPIService.MAX_LIMIT };

    const response = await this.get<Result<Template>>(endpoint, queryParams);

    return response.results;
  }
}
